import { render, staticRenderFns } from "./PreparoInox.vue?vue&type=template&id=6ccfe57a&"
import script from "./PreparoInox.vue?vue&type=script&lang=js&"
export * from "./PreparoInox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports